interface IndexItem {
  title: string;
  count: number;
  tag: string;
  hot?: boolean;
  icon: string;
}

const indexItems: IndexItem[] = [
  { title: '古装剧集', count: 286, tag: '宫廷·仙侠·武侠', hot: true, icon: 'ri-book-open-line' },
  { title: '悬疑推理', count: 194, tag: '刑侦·心理·反转', icon: 'ri-magic-line' },
  { title: '都市情感', count: 312, tag: '爱情·职场·家庭', hot: true, icon: 'ri-heart-pulse-line' },
  { title: '科幻奇幻', count: 147, tag: '未来·异能·穿越', icon: 'ri-planet-line' },
  { title: '韩剧专区', count: 228, tag: '浪漫·治愈·烧脑', hot: true, icon: 'ri-kakao-talk-fill' },
  { title: '美剧精选', count: 173, tag: '剧情·喜剧·科幻', icon: 'ri-global-line' },
  { title: '热血动漫', count: 415, tag: '日漫·国漫·剧场版', icon: 'ri-fire-fill' },
  { title: '日剧精选', count: 136, tag: '治愈·美食·职场', icon: 'ri-sun-line' },
  { title: '综艺娱乐', count: 259, tag: '真人秀·音乐·脱口秀', icon: 'ri-emotion-happy-line' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          追剧索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">按类型快速找到你想看的剧，海量片单持续更新</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href={`#${item.title}`}
              className="group flex items-center gap-4 bg-background-50 rounded-xl p-4 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all cursor-pointer"
              onClick={(e) => e.preventDefault()}
            >
              <span className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors shrink-0">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="font-heading text-sm text-foreground-900 truncate">{item.title}</h3>
                  {item.hot && (
                    <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap">热门</span>
                  )}
                </div>
                <p className="text-xs text-foreground-400 mb-1">{item.tag}</p>
                <p className="text-xs text-foreground-500">{item.count} 部剧集</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}